import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=27c8b96c&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=27c8b96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c8b96c",
  null
  
)

export default component.exports